import InputPhoto from "../../InputPhoto";
import React from "react";
import Editor from "../../../../UI/Editors/Editor";

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
    ]
}

const formate = [
    'bold', 'italic', 'underline', 'strike',
]

const CreateSearchAbout = ({register, setImages, images, errors, error, editorRefAbout}) => {
    return(
        <div className="create_ads_m_block create_ads_border">
            <div className="advers___title">Описание:</div>

            <div className="input_wrap input_wrap_100">
                <input className="input" type="text" placeholder='Введите заголовок' {...register('name')}/>
                <p className="error">{errors.name?.message}</p>
            </div>

            <div className="input_wrap input_wrap_100">
                <Editor editorRef={editorRefAbout} formats={formate} modules={modules} placeholder={'Описание требуемой услуги'}/>
                <p className="error">{errors.about?.message}</p>
            </div>

            <InputPhoto
                images={images}
                onLoad={setImages}
                onDelete={setImages}
                maxCount={5}
                limitText={"До 5-ти фото."}
                errorText={error}
            />
        </div>
    )
}

export default CreateSearchAbout;